export default __webpack_public_path__ + "img/tab1and2_nav4-1-821142b4.png";